//https://redux.js.org/introduction/why-rtk-is-redux-today#what-does-the-redux-core-do

import { configureStore } from '@reduxjs/toolkit'

import { usersSlice, unitsSlice, userUpdateslice, userInfoSlice, updatePasswordslice, permissionListSlice } from 'slices/user/user.slice';
import { registrationSlice } from 'slices/user/registration.slice';

import loginSlice from 'slices/user/login.slice';

import userTypeSlice from 'slices/dropdown/userType.slice';

import { dashboardSlice, } from 'slices/dashboard/dashboard.slice';
import { reportListSlice, reportListByCategoryHorizontalSlice, reportListByCategoryVsBrandSlice, reportListByDepartmentVsCategorySlice } from 'slices/report/report.slice';
import { assetAddSlice, assetUpdateSlice, assetListSlice, assetDetailSlice } from 'slices/asset/asset.slice';
import { softAssetAddSlice, softAssetUpdateSlice, softAssetListSlice, softAssetDetailSlice } from 'slices/softAsset/softAsset.slice';
import { categoryAddSlice, categoryUpdateSlice, categoryListSlice } from 'slices/other/category.slice';
import { brandAddSlice, brandUpdateSlice, brandListSlice } from 'slices/other/brand.slice';
import { departmentAddSlice, departmentUpdateSlice, departmentListSlice } from 'slices/other/department.slice';
import { designationAddSlice, designationUpdateSlice, designationListSlice } from 'slices/other/designation.slice';
import { vendorAddSlice, vendorUpdateSlice, vendorListSlice, vendorNameListSlice } from 'slices/vendor/vendor.slice';
import { employeeAddSlice, employeeUpdateSlice, employeeListSlice, employeeNameListSlice, employeeIdListSlice, employeeDetailSlice, employeeAssetListSlice } from 'slices/employee/employee.slice';

import { cpuAddSlice, cpuUpdateSlice, cpuListSlice } from 'slices/other/cpu.slice';
import { genAddSlice, genUpdateSlice, genListSlice } from 'slices/other/gen.slice';
import { memoryAddSlice, memoryUpdateSlice, memoryListSlice } from 'slices/other/memory.slice';
import { hddAddSlice, hddUpdateSlice, hddListSlice } from 'slices/other/hdd.slice';
import { ssdAddSlice, ssdUpdateSlice, ssdListSlice } from 'slices/other/ssd.slice';
import { colorAddSlice, colorUpdateSlice, colorListSlice } from 'slices/other/color.slice';
import { gpuAddSlice, gpuUpdateSlice, gpuListSlice } from 'slices/other/gpu.slice';
import { displayAddSlice, displayUpdateSlice, displayListSlice } from 'slices/other/display.slice';
import { currencyAddSlice, currencyUpdateSlice, currencyListSlice } from 'slices/other/currency.slice';


const reducer = {
  users: usersSlice.reducer,
  userInfo: userInfoSlice.reducer,
  units: unitsSlice.reducer,
  login: loginSlice,
  registration: registrationSlice.reducer,
  userUpdate: userUpdateslice.reducer,
  updatePassword: updatePasswordslice.reducer,

  userType: userTypeSlice,
  dashboard: dashboardSlice.reducer,
  reportList: reportListSlice.reducer,
  reportListByCategoryHorizontal: reportListByCategoryHorizontalSlice.reducer,
  reportListByCategoryVsBrand: reportListByCategoryVsBrandSlice.reducer,
  reportListByDepartmentVsCategory: reportListByDepartmentVsCategorySlice.reducer,

  permissionList: permissionListSlice.reducer,

  assetAdd: assetAddSlice.reducer,
  assetUpdate: assetUpdateSlice.reducer,
  assetList: assetListSlice.reducer,
  assetDetail: assetDetailSlice.reducer,

  softAssetAdd: softAssetAddSlice.reducer,
  softAssetUpdate: softAssetUpdateSlice.reducer,
  softAssetList: softAssetListSlice.reducer,
  softAssetDetail: softAssetDetailSlice.reducer,

  categoryAdd: categoryAddSlice.reducer,
  categoryUpdate: categoryUpdateSlice.reducer,
  categoryList: categoryListSlice.reducer,

  brandAdd: brandAddSlice.reducer,
  brandUpdate: brandUpdateSlice.reducer,
  brandList: brandListSlice.reducer,

  departmentAdd: departmentAddSlice.reducer,
  departmentUpdate: departmentUpdateSlice.reducer,
  departmentList: departmentListSlice.reducer,

  designationAdd: designationAddSlice.reducer,
  designationUpdate: designationUpdateSlice.reducer,
  designationList: designationListSlice.reducer,

  vendorAdd: vendorAddSlice.reducer,
  vendorUpdate: vendorUpdateSlice.reducer,
  vendorList: vendorListSlice.reducer,
  vendorNameList: vendorNameListSlice.reducer,

  employeeAdd: employeeAddSlice.reducer,
  employeeUpdate: employeeUpdateSlice.reducer,
  employeeList: employeeListSlice.reducer,
  employeeNameList: employeeNameListSlice.reducer,
  employeeIdList: employeeIdListSlice.reducer,
  employeeDetail: employeeDetailSlice.reducer,
  employeeAssetList: employeeAssetListSlice.reducer,

  cpuAdd: cpuAddSlice.reducer,
  cpuUpdate: cpuUpdateSlice.reducer,
  cpuList: cpuListSlice.reducer,

  genAdd: genAddSlice.reducer,
  genUpdate: genUpdateSlice.reducer,
  genList: genListSlice.reducer,

  memoryAdd: memoryAddSlice.reducer,
  memoryUpdate: memoryUpdateSlice.reducer,
  memoryList: memoryListSlice.reducer,

  hddAdd: hddAddSlice.reducer,
  hddUpdate: hddUpdateSlice.reducer,
  hddList: hddListSlice.reducer,

  ssdAdd: ssdAddSlice.reducer,
  ssdUpdate: ssdUpdateSlice.reducer,
  ssdList: ssdListSlice.reducer,

  colorAdd: colorAddSlice.reducer,
  colorUpdate: colorUpdateSlice.reducer,
  colorList: colorListSlice.reducer,

  gpuAdd: gpuAddSlice.reducer,
  gpuUpdate: gpuUpdateSlice.reducer,
  gpuList: gpuListSlice.reducer,

  displayAdd: displayAddSlice.reducer,
  displayUpdate: displayUpdateSlice.reducer,
  displayList: displayListSlice.reducer,

  currencyAdd: currencyAddSlice.reducer,
  currencyUpdate: currencyUpdateSlice.reducer,
  currencyList: currencyListSlice.reducer,

}


export default configureStore({
  reducer: reducer,
  devTools: true,
})
